/**
 * Session-scoped impression cap for FeedbackNugget components.
 *
 * Limits how many nuggets a user sees per browser session to avoid
 * survey fatigue. Uses sessionStorage so the cap resets on new tabs.
 */

const SESSION_KEY = 'feedback_nugget_impressions';
const MAX_IMPRESSIONS = 2;

export function canShowNugget(): boolean {
  const count = parseInt(sessionStorage.getItem(SESSION_KEY) || '0', 10);
  return count < MAX_IMPRESSIONS;
}

export function recordNuggetImpression(): void {
  const count = parseInt(sessionStorage.getItem(SESSION_KEY) || '0', 10);
  sessionStorage.setItem(SESSION_KEY, String(count + 1));
}
